<template>
  <v-dialog v-model="isOpen" max-width="800">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <div>
          {{
            this.$t(
              "employeeGroup.examinationsDialog.assignedExaminations.title"
            )
          }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="examinationAssignments"
          :headers="headers"
          :items-per-page="10"
          :search="search"
          :options.sync="tableDataGetter.pagination"
          :footer-props="{
            itemsPerPageOptions: tableDataGetter.pagination.rowsPerPageItems,
            itemsPerPageText: $t('general.rowsPerPage'),
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-text-field
                style="max-width: 370px"
                v-model="search"
                :label="$t('general.search')"
                id="search-all"
                single-line
                hide-details
                dense
                clearable
                @click:clear="handleClickClear()"
              ></v-text-field>
              <v-btn text icon color="secondary">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.examination.name="{ item }">
            {{ item.examination.name }}
          </template>
          <template v-slot:item.interval="{ item }">
            {{
              $tc(
                "employeeGroup.examinationsDialog.assignedExaminations.interval",
                item.interval,
                { count: item.interval }
              )
            }}
          </template>
        </v-data-table>
      </v-card-text>

      <v-spacer />

      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" v-on:click="isOpen = false">{{
          $t("general.back")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "employeeGroupTableExaminationDialog",
  props: ["examinationAssignments"],
  computed: {
    ...mapGetters(["tableDataGetter"]),
  },
  data() {
    return {
      search: "",
      isOpen: false,
      headers: [
        {
          text: this.$t("employeeGroup.examinationsDialog.name"),
          value: "examination.name",
          align: "left",
        },
        {
          text: this.$t("employeeGroup.examinationsDialog.interval"),
          value: "interval",
          align: "left",
        },
      ],
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
  },
};
</script>
